// frontend/src/pages/BulkAnalysisPage/DeployModal.jsx

import React from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogTitle, DialogContent, IconButton, Box, Typography, Tooltip, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import DownloadIcon from '@mui/icons-material/Download';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

const DeployModal = ({ isOpen, onClose, onDownloadDcm, isExporting }) => {
    const { t } = useTranslation();

    // A reusable component for rendering each deploy option card
    const DeployOption = ({ title, description, icon, onClick, disabled = false, tooltip = '' }) => {
        const content = (
            <Box
                className={`method-option-box ${disabled ? 'disabled' : ''}`}
                onClick={!disabled ? onClick : undefined}
            >
                <Box display="flex" alignItems="center" gap={2}>
                    <Box className="method-icon-wrapper">
                        {/* Show spinner only for the active, non-disabled option */}
                        {isExporting && !disabled ? (
                            <CircularProgress size={28} sx={{ color: 'rgba(255, 255, 255, 0.9)' }} />
                        ) : (
                            icon
                        )}
                    </Box>
                    <Box>
                        <Typography variant="subtitle1" fontWeight="bold">{title}</Typography>
                        <Typography variant="body2">{description}</Typography>
                    </Box>
                </Box>
            </Box>
        );

        // Only wrap with Tooltip if the item is disabled and has tooltip text
        return disabled && tooltip ? (
            <Tooltip title={tooltip} arrow>
                {/* The disabled state is handled by the className, so the Tooltip wrapper doesn't need an extra div */}
                {content}
            </Tooltip>
        ) : content;
    };

    return (
        <Dialog 
            open={isOpen} 
            onClose={onClose} 
            maxWidth="sm" 
            fullWidth
            PaperProps={{
                className: "deploy-modal-dialog"
            }}
        >
            <DialogTitle>
                {t('bulkAnalysisPage.deployModal.title')}
                <IconButton aria-label="close" onClick={onClose} sx={{ position: 'absolute', right: 8, top: 8, color: 'grey.500' }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                 <Typography variant="h6" gutterBottom sx={{ color: 'rgba(255, 255, 255, 0.9)' }}>
                    {t('bulkAnalysisPage.deployModal.chooseMethod')}
                 </Typography>
                
                <DeployOption
                    title={t('bulkAnalysisPage.deployModal.manualMethodTitle')}
                    description={t('bulkAnalysisPage.deployModal.manualMethodDescription')}
                    icon={<DownloadIcon />}
                    onClick={onDownloadDcm}
                    disabled={isExporting}
                />

                <DeployOption
                    title={t('bulkAnalysisPage.deployModal.apiMethodTitle')}
                    description={t('bulkAnalysisPage.deployModal.apiMethodDescription')}
                    icon={<CloudUploadIcon />}
                    disabled={true}
                    tooltip={t('bulkAnalysisPage.deployModal.apiTooltip')}
                />

            </DialogContent>
        </Dialog>
    );
};

export default DeployModal;